import * as React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as WarningIcon } from 'assets/images/ic-modal-alert.svg';
import { Button, Dialog, Header, Text } from 'ui';

interface Props {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  onSave: () => void;
  sectionName: string;
}

export const ConfirmSectionDeleteModal: React.FC<Props> = (props) => {
  return (
    <Dialog noActions isOpen={props.isOpen} handleClose={() => props.setIsOpen(false)} width="459px">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 0' }}>
        <Box sx={{ padding: '0 0 20px 0' }}>
          <WarningIcon />
        </Box>
        <Box sx={{ padding: '0 0 20px 0' }}>
          <Header type="h2" content={`Remove ${props.sectionName}?`} />
        </Box>
        <Box sx={{ padding: '0 0 50px 0', textAlign: 'center' }}>
          <Text
            content={`Are you sure you want to remove ${props.sectionName}?
This action will delete all fields entered for this section.`}
          />
        </Box>
        <Button
          label={`Remove ${props.sectionName}`}
          color="warning"
          onClick={() => {
            props.onSave();
            props.setIsOpen(false);
          }}
          width="335px"
        />
        <Box sx={{ padding: '8px 0 20px 0' }}>
          <Button
            label="Cancel"
            color="secondary-outlined"
            onClick={() => {
              props.setIsOpen(false);
            }}
            width="335px"
          />
        </Box>
      </Box>
    </Dialog>
  );
};
